import {
  Button,
  Card,
  CardContent,
  CardActions,
  makeStyles,
} from "@material-ui/core";
import { SectionTitle } from "../../UI/Typographies";
import { lang } from "../../../i18nLang";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "30vw",
    margin: "1.5rem auto",
    padding: theme.spacing(6, 2),
  },
  title: { textTransform: "uppercase", textAlign: "center" },
  content: {
    minHeight: "calc(60vh - 116px)",
    padding: theme.spacing(4, 12),
    paddingTop: 0,
  },
  actions: { justifyContent: "center" },
}));

const FormCard = ({
  title,
  TabsStepper,
  children,
  finished,
  disabledButton,
  onNext,
  onFinish,
}) => {
  const classes = useStyles();

  return (
    <Card className={classes.root}>
      <SectionTitle className={classes.title}>{title}</SectionTitle>
      <TabsStepper />
      <CardContent className={classes.content}>{children}</CardContent>
      <CardActions className={classes.actions}>
        {!finished && (
          <Button color="primary" disabled={disabledButton} onClick={onNext}>
            {lang("continue")}
          </Button>
        )}
        {finished && (
          <Button
            color="primary"
            variant="contained"
            disabled={disabledButton}
            onClick={onFinish}
          >
            {lang("create")}
          </Button>
        )}
      </CardActions>
    </Card>
  );
};

export default FormCard;
